// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_2m8WF","avatarImage":"_2x5E5","profileName":"_3cQTD","reply":"YSrMB","profileInfo":"_3k5Rr"};